import {createEntityAdapter, createSlice, EntityId} from '@reduxjs/toolkit';
import {mapValues} from 'lodash';
import {AdminEntity} from '~/types/models/admin';
import {RootState} from '~/redux/root-reducer';
import {
  addIdsToSources,
  createSelectAllBySource,
  DEFAULT_SOURCE_REDUCER_STATE,
  deleteSuccess,
  fetchSuccess,
  ReducerState,
  upsertMany,
  upsertManyMutably,
  upsertOneMutably,
} from 'redux-thunk-kit';
import {SOURCES_ADMIN} from '~/redux/admins/entity-config';
// import {addAdmin, deleteAdmin, fetchAdmins, updateAdmin} from '~/redux/admins/thunk';

interface InitialState extends ReducerState {}

const sources = mapValues(SOURCES_ADMIN, () => DEFAULT_SOURCE_REDUCER_STATE);

const adminsAdapter = createEntityAdapter<AdminEntity>();

const initialState = adminsAdapter.getInitialState<InitialState>({sources});

const admins = createSlice({
  name: 'admins',
  initialState,
  reducers: {},
  extraReducers: builder => {
    // builder.addCase(fetchAdmins.fulfilled, (state, {payload}) => {
    //   upsertManyMutably(adminsAdapter, state, payload.normalized.entities.admins);
    //   fetchSuccess(state, payload);
    // });
    // builder.addCase(addAdmin.fulfilled, (state, {payload}) => {
    //   upsertMany(adminsAdapter, state, payload.normalized.entities.admins);
    //   addIdsToSources(state, payload.normalized.result, [SOURCES_ADMIN.ADMINS_PAGE]);
    // });
    // builder.addCase(updateAdmin.fulfilled, (state, {payload}) => {
    //   upsertOneMutably(adminsAdapter, state, payload.normalized.entities.admins);
    // });
    // builder.addCase(deleteAdmin.fulfilled, (state, {payload, meta}) => {
    //   const {arg} = meta;
    //   adminsAdapter.removeOne(state, arg?.id as EntityId);
    //   deleteSuccess(state, arg?.id);
    // });
  },
});

// export const {} = admins.actions;

export default admins.reducer;

export const {
  selectById: selectAdminById,
  selectIds: selectAdminsIds,
  selectEntities: selectAdminsEntities,
  selectAll: selectAllAdmins,
  selectTotal: selectTotalAdmins,
} = adminsAdapter.getSelectors((state: RootState) => state.admins);

export const [getAdmins] = createSelectAllBySource('admins', selectAdminsEntities, [SOURCES_ADMIN.ADMINS_PAGE]);
